import { NOTIFICATION_BROADCAST_TYPE } from "@/entities/notification-broadcast";
import { useEventBusListener } from "@/modules/event-bus";

import { useObservationActionTransition } from "./observation-action-transition.hook";

export const ObservationActionTransition = () => {
  const { runAction } = useObservationActionTransition();

  useEventBusListener(
    NOTIFICATION_BROADCAST_TYPE.OBSERVATION_TRANSITION,
    runAction
  );

  return <></>;
};
